<template>
    <div>
        <!-- Toolbar -->
        <portal to="navigation" :order="1">
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bolder font-size-sm px-5"
                data-toggle="modal" data-target="#exampleModal">
                <i class="fas fa-plus"></i>&nbsp;{{ __('actions.user.add') }}
            </button>
        </portal>

        <!-- Modal-->
        <div ref="modal" class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
             aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{ __('store.select_store_user') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </div>
                    <div class="modal-body d-flex justify-content-center">
                        <div class="w-75">
                            <form-group required reference-id="email" :error="form.errors.email"
                                        :label="__('store.select_user')">
                                <input v-model="form.email" type="email" id="email"
                                       class="text-capitalize form-control" :class="checkError(form.errors.email)"
                                       required/>
                            </form-group>
                            <form-group required reference-id="role" :error="form.errors.role_id"
                                        :label="__('store.select_role')">
                                <multiselect
                                    id="role"
                                    :class="checkError(form.errors.role_id)"
                                    required
                                    v-model="selectedRole"
                                    track-by="id"
                                    label="name"
                                    :options="roles">
                                </multiselect>
                            </form-group>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light-primary font-weight-bold" data-dismiss="modal">
                            {{ __('actions.abort') }}
                        </button>
                        <button type="button" class="btn btn-primary font-weight-bold" @click="addUser">
                            {{ __('actions.add') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Multiselect from 'vue-multiselect'
import {Portal} from 'portal-vue'
import FormGroup from '@components/Form/FormGroup.vue'

export default {
    name: 'AddUserToStoreModal',

    components: {
        FormGroup,
        Multiselect,
        Portal,
    },

    props: {
        storeUuid: String,
        roles: Array,
    },

    data() {
        return {
            selectedRole: '',
            form: this.$inertia.form({
                email: '',
                role_id: '',
            }),
        }
    },

    methods: {
        addUser() {
            this.form.role_id = this.selectedRole.id

            this.form.post(this.$route('store.add_user', this.storeUuid), {
                onSuccess: () => {
                    this.$emit('userAdded')
                    $(this.$refs.modal).modal('hide')
                    this.selectedRole = ''
                },
            })
        },
        checkError(message) {
            return message !== undefined ? 'is-invalid' : this.wasValidated
        },
    },
}
</script>
